import type { JSX } from 'react';
import { LegalPage } from './LegalPage';

export function ResponsiblePlay(): JSX.Element {
  return <LegalPage slug="responsible-play" />;
}

export default ResponsiblePlay;
